module.exports = __webpack_public_path__ + "jm.7fe374125edda998d6b6.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/jm.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/jm.svg
// module chunks = styles